import type { AutomationNotification } from "@/modules/automations/redesign/fixtures-deep";
import { unresolvedCount } from "@/modules/automations/redesign/notifications";

/**
 * The Automations rail item shows a notification dot when any automation
 * notification is unresolved — a pending sign-off or blocking question (never a
 * resolved/done one). Mirrors the email item's boolean `hasUnread` badge, so
 * pending automation sign-offs are visible from anywhere in the app, not just
 * inside the pane.
 */
export function automationsRailHasUnread(notifs: AutomationNotification[]): boolean {
  return unresolvedCount(notifs) > 0;
}
